/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Ex_IntroInputs */

const en_to_xml_ex_intro = /** @type {(inputs: To_Xml_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note the escaped ampersand, the repeated tags element, and the self closing element for null.`)
};

const ko_to_xml_ex_intro = /** @type {(inputs: To_Xml_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이스케이프된 앰퍼샌드, 반복되는 tags 요소, null에 대한 자기 종결 요소를 보세요.`)
};

const ja_to_xml_ex_intro = /** @type {(inputs: To_Xml_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エスケープされたアンパサンド、繰り返される tags 要素、null に対する自己終了要素を見てください。`)
};

/**
* | output |
* | --- |
* | "Note the escaped ampersand, the repeated tags element, and the self closing element for null." |
*
* @param {To_Xml_Ex_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_ex_intro = /** @type {((inputs?: To_Xml_Ex_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Ex_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_ex_intro(inputs)
	if (locale === "ko") return ko_to_xml_ex_intro(inputs)
	return ja_to_xml_ex_intro(inputs)
});